import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import LoaderSpinner from 'components/LoaderSpinner';
import Icon from 'components/Icon';
import colors from 'assets/styles/jsVariables/colors';
import './ModalContent.scss';

const emailIconMap = {
  [colors.msThemePrimary]: 'email-teal'
};

const Verification = ({ themeColor, description, status }) => (
  <React.Fragment>
    <div className="Modal__Content__Text">
      <FormattedMessage id={description} />
    </div>
    <LoaderSpinner>
      <Icon
        name={emailIconMap[themeColor.primary] || 'email-blue'}
        className="Modal__Content__Loader__Icon"
      />
    </LoaderSpinner>
    <div className="Modal__Content__Status">
      <FormattedMessage id={status} />
    </div>
  </React.Fragment>
);

export default Verification;

Verification.propTypes = {
  themeColor: PropTypes.object,
  description: PropTypes.string,
  status: PropTypes.string
};

Verification.defaultProps = {
  themeColor: {},
  description: 'verification.modal.content.text',
  status: 'verification.modal.content.status'
};



// WEBPACK FOOTER //
// ./src/components/ModalContent/Verification.jsx